import { Clinic } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

export function useClinicById(clinicId: string | undefined) {
  const { token } = useAuth()
  const { data, error, mutate, isLoading } = useGet<{ success: boolean; data: Clinic }>(
    token && clinicId ? `/api/clinics/${clinicId}` : null,
    undefined,
    token ?? '',
  )

  return {
    clinic: data?.data,
    isLoading,
    isError: error,
    mutate,
  }
}
